import { useResourceFormContext as useFrameworkFormContext } from "src/components/Form/hooks/useResourceFormContext.ts";

export const useResourceFormLang = () => {
  const { lang } = useFrameworkFormContext();
  return lang;
};
